angular
    .module('eficienciaFiscalModule')
    .filter('listObjectArrayAttr', function () {
        return function (value, attr, noItemMsg, separator) {
            var text = "",
                separator = separator || ', '
            angular.forEach(value, function (value) {
                if (text == "")
                    text = eval("value." + attr);
                else
                    text += separator + eval("value." + attr);
            })
            if (text == "")
                text = noItemMsg;
            return text;
        }
    })
